import React from "react";
import ButtonComponent from "../ButtonComponent";
import ListComponent from "../ListComponent";
import LabelComponent from "../LabelComponent";
import LineComponent from "../LineComponent";
import TextComponent from "../TextComponent";
import FieldComponent from "../FieldComponent/FieldComponent";
import CheckboxComponent from "../CheckboxComponent";
import ArrayFields from "../ArrayFields";
import ChatComponent from "../ChatComponent";
import TabsComponent from "../TabsComponent/TabsComponent";
import CardComponent from "../CardComponent";
import BlockComponent from "../BlockComponent";
import SurveyComponent from "../SurveyComponent";
import ImageComponent from "../ImageComponent";
import Panel from "../../Grid/Panel";
import EmbeddedScreenComponent from "../EmbeddedScreen";
import StepperComponent from "../Stepper";
import ProgressComponent from "../ProgressComponent";
import SelectionCriteriaComponent from "../SelectionCriteriaComponent";
import Feed from "../../../../../../../JsonScreen/Screen/ScreenComponents/Feed";
import FeedPost from "../../../../../../../JsonScreen/Screen/ScreenComponents/FeedPost";
import ForEach from "../ForEachComponent";
import ActionsBar from "../Templates/ActionsBar";
import BottomMenuComponent from "../BottomMenuComponent";
import Maps from "../Maps/Maps";
import DropzoneComponent from "../Dropzone";
import IconComponent from "../IconComponent";
import SearchBarComponent from "../SearchBarComponent";
import HeaderComponent from "../HeaderComponent";
import SidebarComponent from "../SidebarComponent";
import BadgeComponent from "../Badge";
import RadioGroupComponent from "../RadioGroup";
import RatingComponent from "../Rating";
import MenuComponent from "../MenuComponent";
import BandComponent from "../BandComponent";
import SwiperComponent from "../SwiperComponent/Swiper";
import FooterComponent from "../FooterComponent";
import AccordionComponent from "../AccordionComponent";
import OptionsComponent from "../OptionsComponent";
import FullViewComponent from "../FullViewComponent";
import ServerTime from "../ServerTime";
import PageBreak from "../PageBreak";
import Restrictions from "../Restrictions";
import SwitchComponent from "../SwitchComponent";
import TableComponent from "../TableComponent/TableComponent";
import Tree from "../Tree/Tree";

export const RenderByType = ({type, component, path, index, parentPath}) => {
    switch (type) {
        case 'button':
            return (
                <ButtonComponent
                    component={component}
                />
            );
        case 'list':
            return (
                <ListComponent
                    component={component}
                    path={path}
                    parentPath={parentPath}
                    index={index}
                />
            );
        case 'label':
            return (
                <LabelComponent
                    component={component}
                />
            );
        case 'line':
            return (
                <LineComponent
                    component={component}
                />
            );
        case 'text':
            return (
                <TextComponent
                    component={component}
                />
            );
        case 'field':
            return (
                <FieldComponent
                    component={component}
                />
            );
        case 'checkbox':
            return (
                <CheckboxComponent
                    component={component}

                />
            )
        case 'fieldArray':
            return (
                <ArrayFields
                    component={component}
                    parentPath={parentPath}
                    path={path}
                    index={index}
                />
            );
        case 'chat':
            return (
                <ChatComponent/>
            );
        case 'tabs':
            return (
                <TabsComponent
                    component={component}
                    path={path}
                />
            );
        case 'card':
            return (
                <CardComponent
                    component={component}
                    path={path}
                    index={index}
                />
            );
        case 'block':
            return (
                <BlockComponent
                    component={component}
                    path={path}
                    index={index}
                />
            );
        case 'survey':
            return (
                <SurveyComponent
                    component={component}
                    path={path}
                />
            );
        case 'image':
            return (
                <ImageComponent
                    component={component}
                    path={path}
                />
            );
        case 'panel':
            return (
                <Panel
                    index={index}
                    panel={component}
                    parentPath={''}
                    path={path}
                />
            );
        case 'embeddedScreen':
            return (
                <EmbeddedScreenComponent
                    component={component}
                    path={path}
                />
            );
        case 'stepper':
            return (
                <StepperComponent
                    component={component}
                    parentPath={parentPath}
                    index={index}
                    path={path}
                />
            );
        case 'progress':
            return (
                <ProgressComponent
                    component={component}
                    parentPath={parentPath}
                    index={index}
                    path={path}
                />
            );
        case 'selectionCriteria':
            return (
                <SelectionCriteriaComponent
                    component={component}
                    parentPath={parentPath}
                    index={index}
                    path={path}
                />
            );
        case 'feed':
            return (
                <Feed fromDesigner={true}/>
            );
        case 'feedPost':
            return (
                <FeedPost fromDesigner={true}/>
            );
        case 'forEach':
            return (
                <ForEach
                    component={component}
                    parentPath={parentPath}
                    index={index}
                    path={path}
                />
            );
        case 'actionsBar':
            return (
                <ActionsBar/>
            );
        case 'bottomMenu':
            return (
                <BottomMenuComponent
                    component={component}
                    path={path}
                />
            );
        case 'maps':
            return (
                <Maps
                    component={component}
                    path={path}
                />
            )
        case 'dropzone':
            return (
                <DropzoneComponent
                    component={component}
                    path={path}
                />
            )
        case 'icon':
            return (
                <IconComponent
                    component={component}
                />
            )
        case 'searchBar':
            return (
                <SearchBarComponent
                    component={component}
                />
            )
        case 'header':
            return <HeaderComponent
                component={component}
                path={path}
                index={index}
            />
        case 'sidebar':
            return <SidebarComponent
                component={component}
                path={path}
                index={index}
            />
        case 'badge':
            return <BadgeComponent
                component={component}
                path={path}
                index={index}
            />
        case 'radioGroup':
            return <RadioGroupComponent
                component={component}
                path={path}
                index={index}
            />
        case 'rating':
            return <RatingComponent/>
        case 'menu':
            return <MenuComponent
                component={component}
            />
        case 'band':
            return <BandComponent
                component={component}
                path={path}
                index={index}
            />
        case 'swiper':
            return <SwiperComponent
                component={component}
                path={path}
                index={index}
            />
        case 'footer':
            return <FooterComponent
                component={component}
                path={path}
                index={index}
            />
        case 'accordion':
            return <AccordionComponent
                component={component}
                path={path}
                index={index}
            />
        case 'options':
            return <OptionsComponent
                component={component}
            />
        case 'fullView':
            return <FullViewComponent
                component={component}
            />
        case 'serverTime':
            return <ServerTime
                component={component}
            />
        case 'pageBreak':
            return <PageBreak/>
        case 'restrictions':
            return <Restrictions/>
        case 'switch':
            return <SwitchComponent component={component}/>
        case 'table':
            return <TableComponent path={path} index={index} component={component}/>
        case 'tree':
            return <Tree path={path} index={index} component={component}/>
        default:
            return <>Other Components - {type}</>
    }
};
